/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */
import { DirectiveOptions } from "vue";

/* Désactive de façon fiable la saisie automatique / les valeurs mémorisées du navigateur sur un
   champ. `autocomplete="off"` est ignoré par Chrome sur les champs qu'il classe (nom, adresse,
   e-mail…) et l'app n'a pas de <form> sur lequel poser l'attribut. On garde donc le champ en
   `readonly` au repos — un champ readonly n'est jamais auto-rempli — et on retire l'attribut au
   focus pour permettre la saisie, puis on le remet au blur. Le retrait est différé d'un tick :
   au moment du focus, Chrome déclenche son popup d'autocomplétion (« Gérer les adresses… ») de
   façon synchrone ; si le champ est encore readonly à cet instant, le popup est supprimé, et le
   setTimeout réactive la saisie juste après sans rejouer l'événement focus. */
const directive: DirectiveOptions = {
    bind: ( element: HTMLElement ): void => {
        /* `autocomplete="off"` est ignoré par Chrome sur les champs qu'il classe (nom, e-mail,
           adresse…). Un jeton `autocomplete` aléatoire et non reconnu désactive ses heuristiques de
           remplissage, et les attributs data-*ignore désactivent les gestionnaires de mots de passe
           courants (LastPass, 1Password). */
        const token = "no-autofill-" + Math.random().toString( 36 ).slice( 2 );

        element.setAttribute( "autocomplete", token );
        element.setAttribute( "data-lpignore", "true" );
        element.setAttribute( "data-1p-ignore", "true" );
        element.setAttribute( "data-form-type", "other" );

        if( element.getAttribute( "name" ) === null )
            element.setAttribute( "name", token );

        element.setAttribute( "readonly", "readonly" );

        element.addEventListener( "focus", (): void => {
            setTimeout( (): void => {
                element.removeAttribute( "readonly" );
            }, 0 );
        } );

        element.addEventListener( "blur", (): void => {
            element.setAttribute( "readonly", "readonly" );
        } );
    }
};

export default directive;
